<template>
  <div class="col-five">
    <div class="purchase-list__one-product">
      <div class="purchase-list__one-product-img">
        <img :src="product.photo" alt="" />
      </div>
      <div class="purchase-list__one-product-title">
        {{ sliceProductNameWord }}
      </div>
      <div class="purchase-list__one-product-no mb-2">
        {{ product.product_no }}
      </div>
      <div class="purchase-list__one-product-price">
        $ {{ product.max_price }}
      </div>
      <button class="transparent-btn" @click="chooseProduct">
        <!-- @click="$bvModal.show(`product-modal${id}`)" -->

        <span class="icon-icon_cart"></span>
        加入購物車
      </button>
    </div>
    <!-- <ProductModal :id="id" /> -->
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: Number,
      required: true
    },
    product: {
      type: Object,
      required: true
    }
  },
  components: {
    // ProductModal
  },
  computed: {
    sliceProductNameWord() {
      if (this.product.name.length >= 23) {
        return this.product.name.substring(0, 23) + '...';
      } else {
        return this.product.name;
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    chooseProduct() {
      this.$emit('chooseProduct', this.product.product_id);
    }
  }
};
</script>
